// Contribution type discriminators sent to the backend on contribution
// mutations. Historically these were loose inline string literals in
// `services/contributionService.ts` ("REGULAR" for bank ACH, "EMPLOYER" for
// PRP payroll). New code should reference these constants instead of
// hard-coding the strings; existing call sites are left untouched.
export const contributionTypes = {
  REGULAR: "REGULAR",
  EMPLOYER: "EMPLOYER",
  // Paychex Flex (Perks): an individual payroll deduction keyed off a Paychex
  // worker record rather than an employer group. Apex classifies the resulting
  // VAN deposit as a normal contribution via the PAYROLL nacha flag.
  PAYCHECK_SPLIT: "PAYCHECK_SPLIT",
} as const;

export type ContributionType =
  (typeof contributionTypes)[keyof typeof contributionTypes];
